function Footer() {
    return ( 
        <>
            <div className="footer">해당 사이트의 단어는 네이버사전을 기반으로 만들어졌습니다.</div>
        </>
     );
}

export default Footer;